<template>
    <div class="el-field-input">
        <!-- 不同类型渲染对应的输入组件 -->
        <el-input v-if="type === 'string' || type === 'number'" :type="type === 'number' ? 'number' : 'text'"
            v-model="innerValue" :placeholder="placeholder" :class="{ 'is-error': errorMsg }" :disabled="disabled" @input="handleInput" @blur="handleBlur"/>

        <el-date-picker v-else-if="type === 'date'" v-model="innerValue" :placeholder="placeholder" type="date"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd" :class="{ 'is-error': errorMsg }" @change="handleInput" @blur="handleBlur" :disabled="disabled" />

        <el-select v-else-if="type === 'select'" v-model="innerValue" :placeholder="placeholder"  @change="handleInput" @blur="handleBlur"
            clearable filterable :class="{ 'is-error': errorMsg }" :disabled="disabled">
            <el-option v-for="(item, index) in options" :key="index" :label="item" :value="item" />
        </el-select>

        <!-- 错误提示 -->   
        <div v-if="errorMsg" class="error-msg">{{ errorMsg }}</div>
    </div>
</template>

<script>
export default {
    name: 'ElFieldInput',
    props: {
        value: [String, Number, Date],
        type: {
            type: String,
            default: 'string',
        },
        placeholder: String,
        required: Boolean,
        rules: {
            type: Array,
            default: () => [],
        },
        options: {
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        validateTrigger: {
            type: String,
            default: 'blur', // 'input', 'blur', or 'manual'
        },
        arrRules: {
            type: Array,
            default: () => [],
        },
        label: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            innerValue: this.value,
            errorMsg: '',
            rulesMap: {
                integer: [
                    {
                        validator: (val) => {
                            if (!/^\d+$/.test(val)) {
                                return '只能输入数字';
                            }
                            return '';
                        }
                    },
                    {
                        validator: (val) => {
                            if (String(val).indexOf('.') !== -1) {
                                return '只能输入整数';
                            }
                            return '';
                        }
                    },
                    {
                        validator: (val) => {
                            if (+val < 1) {
                                return '只能输入大于0的整数';
                            }
                            return '';
                        }
                    },

                ]
            }
        };
    },
    watch: {
        value(val) {
            this.innerValue = val;
        },
        innerValue(val) {
            this.$emit('input', val);
            if (this.validateTrigger === 'input') {
                this.validate();
            }
        }
    },
    methods: {
        handleInput() {
            if (this.validateTrigger === 'input') {
                this.validate();
            }
        },
        handleBlur() {
            if (this.validateTrigger === 'blur') {
                this.validate();
            }
        },
        validate() {
            return new Promise((resolve, reject) => {
                this.errorMsg = '';
                if (this.required && (this.innerValue === '' || this.innerValue == null)) {
                    this.errorMsg = '此项为必填项';
                    return reject(this.label ? this.label + '为必填项' : '此项为必填项');
                }
                const rules = this.rules;
                for(let item of this.arrRules){
                    rules.push(...this.rulesMap[item]);
                }

                for (const rule of rules) {
                    if (rule.pattern && !rule.pattern.test(this.innerValue)) {
                        this.errorMsg = rule.message;
                        return reject(this.label ? this.label + ' ' + this.errorMsg : this.errorMsg);
                    }
                    if (rule.validator && typeof rule.validator === 'function') {
                        const msg = rule.validator(this.innerValue);
                        if (msg) {
                            this.errorMsg = msg;
                            return reject(this.label ? this.label + ' ' + this.errorMsg : this.errorMsg);
                        }
                    }
                }
                resolve();
            });
        }
    }
};
</script>

<style scoped>
.is-error input,
.is-error .el-input__inner,
.is-error .el-date-editor,
.is-error .el-select {
    border-color: #f56c6c !important;
}

.error-msg {
    color: #f56c6c;
    font-size: 12px;
    margin-top: 4px;
}
</style>
